var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Novo pauta")]),_c('b-card',[_c('Form',{on:{"saved":_vm.loadData}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }